import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import GenerateReport from "@/pages/GenerateReport";
import Templates from "@/pages/Templates";
import TemplateEditor from "@/pages/TemplateEditor";
import Repository from "@/pages/Repository";
import History from "@/pages/History";
import Audit from "@/pages/Audit";
import ReportViewer from "@/pages/ReportViewer";
import Compare from "@/pages/Compare";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="app-shell flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
     <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/generate" element={<GenerateReport />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/:id" element={<TemplateEditor />} />
        <Route path="/repository" element={<Repository />} />
        <Route path="/history" element={<History />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/reports/:id" element={<ReportViewer />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
